import styled from 'styled-components'
import theme from 'theme_'

import { H4 } from 'components/Typography'

export const StyledJobsMain = styled.div``

export const JobsMainRadioTilesWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 10px auto;
  order: 2;

  @media ${theme.devices.tabletLandscape} {
    order: 0;
  }

  @media ${theme.devices.tabletLandscape} {
    width: 384px;
  }
`

export const SelectedDomainTitle = styled(H4)`
  @media ${theme.devices.tablet} {
    font-size: 28px;
    line-height: 40px;
  }
`

export const StyledDomainActions = styled.div`
  display: flex;
`

export const StyledDomainInfo = styled.div`
  display: flex;
  align-items: center;
  margin: ${theme.spacing.base} 0;
`

export const StyledDomainHeader = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  @media ${theme.devices.tabletLandscape} {
    flex-wrap: nowrap;
  }
`

export const JobsSearchDesktopWrapper = styled.div`
  width: 100%;
  display: none;

  @media ${theme.devices.tablet} {
    display: block;
  }
`

export const JobsMainFiltersWrapper = styled.div`
  display: flex;
  max-width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 2;

  @media ${theme.devices.desktop} {
    overflow: unset;
  }
`

export const JobsSearchMobileWrapper = styled.div`
  width: 100%;
  display: block;
  margin-top: ${theme.spacing.xs};

  @media ${theme.devices.tablet} {
    display: none;
  }
`

export const TableWrapper = styled.div`
  display: ${(props) => (props.hidden ? 'none' : 'block')};
`
